import React, { useContext } from "react";
import { Grid, Typography } from "@material-ui/core";
import TaxDocumentNew from "./TaxDocumentNew";
import TaxDocumentList from "./TaxDocumentsList";

//import { getTaxReturn } from "../graphql/queries";

import { UserContext } from "../App";

export default function TaxDocumentsView(props) {
  const {
    user,
    setUser,
    signOutState,
    setSignOutState,
    taxReturn,
    setTaxReturn,
  } = useContext(UserContext);

  return (
    <>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="space-around"
        alignItems="center"
      >
        <Grid item sm={6}>
          <Typography variant="h6">{props.taxDocumentType}</Typography>
        </Grid>
        <Grid item sm={5}>
          <TaxDocumentNew />
        </Grid>
      </Grid>
      <Grid item sm={11}>
        <TaxDocumentList />
      </Grid>
    </>
  );

  /*return <div>{props.taxDocumentType}</div>*/
}
